const excludeKeys = [
    'faqmate_flexDirectionDesk',
    'faqmate_flexDirectionTab',
    'faqmate_flexDirectionMob',
    'faqmate_columnGapRanges',
    'faqmate_rowGapRanges',
    'faqmate_columnGapUnits',
    'faqmate_rowGapUnits',
    'faqmate_icWidthRanges',
    'faqmate_icWidthUnits',
    'faqmate_flexWrapDesk',
    'faqmate_flexWrapTab',
    'faqmate_flexWrapMob',
    'faqmate_alignItemsDesk',
    'faqmate_alignItemsTab',
    'faqmate_alignItemsMob',
    'faqmate_justifyContentDesk',
    'faqmate_justifyContentTab',
    'faqmate_justifyContentMob'
];

export default excludeKeys;
